/* Configure, then add to cart.

   The stand and anything picked with it go in as one group: each is its own
   cart line, and every line carries the same hidden bundle id. The cart reads
   that id to show the companions under the stand they belong to, and the
   product page reads it back off the URL so a buyer can open a line they have
   already added and change the configuration instead of starting again.

   The stand goes up as multipart, because the artwork is a real file attached
   to the line rather than something chased by email afterwards. The companions
   follow as JSON, which is cheaper and carries no file.

   The form is still a real product form. If this file never loads the page
   still posts the stand on its own, which is what it did before. */
(function () {
  "use strict";

  var MAX_FILE = 20 * 1024 * 1024;   /* Shopify's own ceiling for a line item file */
  var DAY = 86400000;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function money(cents) {
    /* Every price in the catalogue is a whole dollar, so a trailing ".00" is
       two characters of noise on every figure on the page. Cents are still
       printed if a figure ever has any. */
    var n = Math.round(cents) / 100;
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    return "$" + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function pretty(d) {
    return d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "long" });
  }

  function clearBundle(bundle) {
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = false;
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._mp_bundle && p._mp_bundle === bundle) { updates[it.key] = 0; found = true; }
        });
        if (!found) return null;
        return fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates })
        });
      });
  }

  function init(root) {
    var form = $(".mps-buyform", root);
    if (!form || form.dataset.mpBuy) return;
    form.dataset.mpBuy = "1";

    var idIn    = $("[data-variant-id]", form);
    var sel     = $("[data-variant-select]", root);
    var qtyIn   = $("[data-qty]", form);
    var btn     = $("[data-add]", form);
    var addons  = $$("[data-addon]", form);
    var mockBtn = $("[data-mockup-open]", form);
    var mockIn  = $("[data-mockup]", form);
    var mockLb  = $("[data-mockup-label]", form);
    var fileIn  = $("[data-artwork]", form);
    var drop    = $("[data-drop]", form);
    var dropLb  = $("[data-drop-label]", form);
    var dateIn  = $("[data-show-date]", form);
    var skuOut  = $("[data-sku]", root);
    var totRow  = $("[data-total-row]", root);
    var totVal  = $("[data-total]", root);
    var totSum  = $("[data-total-lines]", root);
    var errBox  = $("[data-add-error]", root);

    var params = new URLSearchParams(window.location.search);
    var editBundle = params.get("mpedit") || "";
    var carriedArt = params.get("mpart") || "";

    /* ------------------------------------------------------------ price -- */
    function variantCents() {
      if (sel && sel.options.length) {
        var o = sel.options[sel.selectedIndex];
        if (o && o.dataset.cents) return parseInt(o.dataset.cents, 10) || 0;
      }
      return parseInt(form.dataset.basePrice, 10) || 0;
    }
    /* What the buyer has actually asked for in the companion rows.

       A select can only ever hold one answer, so a stand that needs five
       different connectors could be given one of them. Those rows are
       multiple choice now, with a count against each line — mp-pick.js draws
       them — and the answers ride in a hidden field beside the select as
       JSON. The select is still there and still correct for a row where one
       thing was picked, so if the field is missing (no scripting, an older
       cached page) the original reading still applies and nothing breaks. */
    function addonPicks() {
      var out = [];
      addons.forEach(function (s) {
        var carrier = s.parentNode ? s.parentNode.querySelector("[data-addon-cart]") : null;
        if (carrier) {
          var list = [];
          try { list = JSON.parse(carrier.value || "[]") || []; } catch (e) { list = []; }
          list.forEach(function (it) {
            var q = parseInt(it && it.q, 10) || 0;
            if (it && it.id && q > 0) {
              var full = String(it.n || "").trim();
              out.push({
                id: String(it.id),
                qty: q,
                name: full,
                short: String(it.s || "").trim() || full,
                cents: parseInt(it.c, 10) || 0
              });
            }
          });
          return;
        }
        var o = s.options[s.selectedIndex];
        if (o && o.value) {
          out.push({
            id: o.value,
            qty: 1,
            name: (o.dataset.name || o.textContent).trim(),
            short: shortName(o),
            cents: parseInt(o.dataset.price, 10) || 0
          });
        }
      });
      return out;
    }

    function addonCents() {
      var n = 0;
      addonPicks().forEach(function (p) { n += p.cents * p.qty; });
      return n;
    }
    function qty() { return Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1); }

    /* The name of a thing as a buyer would say it, not as the catalogue
       stores it: the option label without the price hanging off the end. */
    function shortName(o) {
      var t = (o.textContent || "").replace(/\s+/g, " ").trim();
      var cut = t.indexOf("\u00b7");
      if (cut > 0) t = t.slice(0, cut);
      return t.trim() || (o.dataset.name || "").trim();
    }

    function sumRow(label, value, cls) {
      return '<span class="mpb-sumrow' + (cls ? " " + cls : "") + '">' +
             "<i>" + label.replace(/&/g, "&amp;").replace(/</g, "&lt;") + "</i>" +
             "<b>" + value + "</b></span>";
    }

    function paint() {
      var extras = addonCents();
      var n = qty();
      var unit = variantCents() + extras;
      if (totVal) totVal.textContent = money(unit * n);
      if (totRow) totRow.hidden = (extras === 0 && n === 1);

      /* Itemise it. A total nobody can check is a total nobody trusts. */
      if (totSum) {
        var rows = [];
        var buildName = "";
        if (sel && sel.options.length) {
          var so = sel.options[sel.selectedIndex];
          buildName = (so && so.dataset.label) || shortName(so || {});
        }
        if (!buildName) buildName = form.dataset.productName || "Stand";
        rows.push(sumRow(buildName, money(variantCents())));
        /* The add-on's own name, not just its variant: two different
           companions can both be called "Complete stand". Five of one thing
           is one line with the count on it, not five identical lines. */
        addonPicks().forEach(function (p) {
          var lbl = p.short || p.name;
          rows.push(sumRow(p.qty > 1 ? (lbl + " \u00d7 " + p.qty) : lbl,
                           money(p.cents * p.qty)));
        });
        if (n > 1) {
          rows.push(sumRow(money(unit) + " each", "\u00d7 " + n, "mult"));
        }
        totSum.innerHTML = rows.join("");
      }

      if (skuOut && sel) {
        var o2 = sel.options[sel.selectedIndex];
        if (o2 && o2.dataset.sku) skuOut.textContent = o2.dataset.sku;
      }
    }

    addons.forEach(function (s) { s.addEventListener("change", paint); });
    if (sel) sel.addEventListener("change", paint);
    if (qtyIn) {
      qtyIn.addEventListener("input", paint);
      qtyIn.addEventListener("change", paint);
    }
    $$("[data-qty-step]", root).forEach(function (b) {
      b.addEventListener("click", function () { window.setTimeout(paint, 0); });
    });

    /* ------------------------------------------------------------- date -- */
    /* Production plus transit. Nothing can be standing in a hall sooner than
       that, so it is the first date the calendar will open on, and seven days
       is the floor whatever the settings say. Nothing is written under the
       field: the date a buyer can pick is the answer. */
    var prodDays    = parseInt(dateIn && dateIn.dataset.prod, 10);
    var transitDays = parseInt(dateIn && dateIn.dataset.transit, 10);
    if (isNaN(prodDays)) prodDays = 2;
    if (isNaN(transitDays)) transitDays = 5;

    function isoLocal(d) {
      return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
        .toISOString().slice(0, 10);
    }
    if (dateIn) {
      var floor = Math.max(7, prodDays + transitDays);
      dateIn.min = isoLocal(new Date(Date.now() + floor * DAY));
    }

    /* ----------------------------------------------------------- upload -- */
    function setDropLabel(text, on) {
      if (dropLb) dropLb.textContent = text;
      if (drop) drop.classList.toggle("has-file", !!on);
    }
    if (fileIn) {
      fileIn.addEventListener("change", function () {
        var f = fileIn.files && fileIn.files[0];
        if (!f) { setDropLabel("Click to attach a file — optional", false); return; }
        if (f.size > MAX_FILE) {
          fileIn.value = "";
          setDropLabel("That file is over 20 MB — send us a link instead", false);
          return;
        }
        carriedArt = "";
        setDropLabel(f.name, true);
      });
    }

    /* ---------------------------------------------------------- mock-up -- */
    /* The button opens a form rather than ticking a box: a mock-up needs the
       artwork and a way of reaching the person who wants it. What comes back
       here afterwards is only the fact that it was asked for, so the cart line
       can say so. */
    var mockNote = $("[data-mockup-note]", form);
    var mockNoteWas = mockNote ? mockNote.textContent : "";

    function setMock(on, email) {
      if (mockIn) mockIn.value = on ? "1" : "";
      if (mockLb) mockLb.textContent = on ? "Mock-up requested" : "Request a free 2D mock-up";
      if (mockBtn) mockBtn.classList.toggle("is-done", !!on);
      if (mockNote) {
        mockNote.textContent = on
          ? ("On its way to " + (email || "you") + " within 24 hours. Ask again to change anything.")
          : mockNoteWas;
      }
    }
    initMockupDialog(root, form, setMock, dateIn, sel);
    if (mockBtn) {
      mockBtn.addEventListener("click", function () {
        var dlg = $("[data-mockup-dialog]", root);
        if (!dlg) return;
        var build = $("[data-mockup-build]", dlg);
        if (build && sel) build.value = sel.options[sel.selectedIndex].dataset.label || "";
        var when = dlg.querySelector('input[name="contact[Show date]"]');
        if (when && dateIn) {
          if (dateIn.min) when.min = dateIn.min;
          if (dateIn.value && !when.value) when.value = dateIn.value;
        }
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", "");
      });
    }

    /* ------------------- reopen a line that is already in the cart ------- */
    /* Written as "id" when one was wanted and "id:count" when more than one
       was, so a line reopened from the cart comes back with its counts and
       not just its names. Both spellings are read, because carts written
       before this change carry the first. */
    var wanted = params.get("mpaddons");
    if (wanted) {
      var want = {};
      wanted.split(",").forEach(function (bit) {
        var kv = String(bit).split(":");
        var id = (kv[0] || "").trim();
        if (id) want[id] = Math.max(1, parseInt(kv[1], 10) || 1);
      });
      window.__mpWantAddons = want;
      addons.forEach(function (s) {
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].value && want[s.options[i].value]) {
            s.selectedIndex = i;
            break;
          }
        }
      });
    }
    if (params.get("mpmock") === "1") setMock(true);
    if (params.get("mpqty") && qtyIn) qtyIn.value = params.get("mpqty");
    if (params.get("mpdate") && dateIn) dateIn.value = params.get("mpdate");
    if (carriedArt) setDropLabel("Artwork already attached — choose a file to replace it", true);
    if (editBundle) {
      if (btn) {
        btn.dataset.labelOn = "Update cart";
        btn.textContent = "Update cart";
      }
      var note = $("[data-edit-note]", root);
      if (note) note.hidden = false;
    }
    paint();

    /* ----------------------------------------------------------- submit -- */
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (errBox) { errBox.hidden = true; errBox.textContent = ""; }
      var revert = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }

      var bundle = "mp" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var n = qty();

      var chosen = addonPicks();

      var standId = idIn && idIn.value ? idIn.value : (sel ? sel.value : "");
      var standName = form.dataset.productName || "your stand";

      var fd = new FormData();
      fd.append("id", standId);
      fd.append("quantity", String(n));
      /* The bundle id and the role are plumbing: the cart reads them to show a
         stand's companions underneath it. They are only written when there is
         something to group. A stand bought on its own carries no hidden
         properties at all, so the order reads as a product, a price and the
         buyer's own answers — nothing a sales agent has to decode. */
      if (chosen.length) {
        fd.append("properties[_mp_bundle]", bundle);
        fd.append("properties[_mp_role]", "stand");
        fd.append("properties[Added with this stand]",
          chosen.map(function (c) {
            return c.qty > 1 ? (c.name + " \u00d7 " + c.qty) : c.name;
          }).join(", "));
        fd.append("properties[_mp_addons]",
          chosen.map(function (c) {
            return c.qty > 1 ? (c.id + ":" + c.qty) : c.id;
          }).join(","));
      }
      if (dateIn && dateIn.value) {
        fd.append("properties[Show date]", dateIn.value);
        if (chosen.length) fd.append("properties[_mp_date]", dateIn.value);
      }
      if (mockIn && mockIn.value === "1") {
        fd.append("properties[Free 2D mock-up]", "Requested — we send it before production");
        if (chosen.length) fd.append("properties[_mp_mock]", "1");
      }
      var f = fileIn && fileIn.files && fileIn.files[0];
      if (f) fd.append("properties[Artwork]", f, f.name);
      else if (carriedArt) fd.append("properties[Artwork]", carriedArt);

      var work = editBundle ? clearBundle(editBundle) : Promise.resolve(null);

      work.then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { Accept: "application/json" },
          body: fd
        });
      }).then(function (r) {
        if (!r.ok) {
          return r.json().then(function (j) {
            throw new Error(j.description || j.message || "That could not be added.");
          });
        }
        if (!chosen.length) return null;
        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: chosen.map(function (c) {
              return {
                id: c.id,
                /* Five connectors on two stands is ten connectors. */
                quantity: c.qty * n,
                properties: { _mp_bundle: bundle, _mp_role: "addon", "Added with": standName }
              };
            })
          })
        });
      }).then(function () {
        window.location.href = "/cart";
      }).catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = revert || "Add to cart"; }
        if (errBox) {
          errBox.textContent = err && err.message ? err.message : "That could not be added.";
          errBox.hidden = false;
        }
      });
    });
  }


  /* ---------------------------------------------------- mock-up dialog -- */
  /* Shopify's contact form carries no attachment, so the file goes to the
     shop's own files first — briefly as a cart line, which is removed again
     the moment the URL comes back — and the message carries the link. If the
     upload cannot be made the request still goes, saying the file will follow. */
  function uploadViaCart(variantId, file) {
    var fd = new FormData();
    fd.append("id", variantId);
    fd.append("quantity", "1");
    fd.append("properties[_mp_mockup_file]", file, file.name);
    return fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { Accept: "application/json" }, body: fd
    }).then(function (r) {
      if (!r.ok) throw new Error("upload");
      return r.json();
    }).then(function (data) {
      var item = (data.items && data.items[0]) || data;
      var url = (item.properties || {})._mp_mockup_file || "";
      var key = item.key;
      if (!key) return url;
      return fetch("/cart/change.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { return url; });
    });
  }

  function initMockupDialog(root, productForm, setMock, dateIn, sel) {
    var dlg = $("[data-mockup-dialog]", root);
    if (!dlg || dlg.dataset.mpm) return;
    dlg.dataset.mpm = "1";

    var mform  = $("[data-mockup-form]", dlg);
    var fileIn = $("[data-mockup-file]", dlg);
    var fileLb = $("[data-mockup-filelabel]", dlg);
    var drop   = $("[data-mockup-drop]", dlg);
    var urlIn  = $("[data-mockup-fileurl]", dlg);
    var errBox = $("[data-mockup-err]", dlg);
    var okBox  = $("[data-mockup-ok]", dlg);
    var send   = $("[data-mockup-send]", dlg);

    function close() {
      if (dlg.close) dlg.close(); else dlg.removeAttribute("open");
    }
    $$("[data-mockup-close]", dlg).forEach(function (b) {
      b.addEventListener("click", close);
    });
    dlg.addEventListener("click", function (e) {
      if (e.target === dlg) close();
    });

    if (fileIn) {
      fileIn.addEventListener("change", function () {
        var f = fileIn.files && fileIn.files[0];
        if (!f) { fileLb.textContent = "Attach a file"; drop.classList.remove("has-file"); return; }
        if (f.size > MAX_FILE) {
          fileIn.value = "";
          fileLb.textContent = "Over 20 MB — tell us below and we will send an upload link";
          drop.classList.remove("has-file");
          return;
        }
        fileLb.textContent = f.name;
        drop.classList.add("has-file");
      });
    }

    mform.addEventListener("submit", function (e) {
      e.preventDefault();
      errBox.hidden = true; errBox.textContent = "";

      var nameIn  = mform.querySelector('input[name="contact[name]"]');
      var emailIn = mform.querySelector('input[name="contact[email]"]');
      if (!nameIn.value.trim()) { fail("Tell us your name so we know who we are writing to.", nameIn); return; }
      if (!emailIn.value.trim() || emailIn.value.indexOf("@") < 1) {
        fail("We need an email address to send the mock-up to.", emailIn); return;
      }

      send.disabled = true;
      var revert = send.textContent;
      send.textContent = "Sending…";

      var f = fileIn && fileIn.files && fileIn.files[0];
      var variantId = productForm.querySelector("[data-variant-id]");
      var up = Promise.resolve("");
      if (f && variantId) {
        send.textContent = "Uploading…";
        up = uploadViaCart(variantId.value, f).catch(function () { return "SENDLATER"; });
      }

      up.then(function (url) {
        if (urlIn) {
          urlIn.value = url === "SENDLATER"
            ? "Could not be attached here — ask the customer to email it"
            : (url || "None attached");
        }
        send.textContent = "Sending…";
        var fd = new FormData(mform);
        return fetch("/contact", { method: "POST", credentials: "same-origin", body: fd });
      }).then(function (r) {
        if (!r.ok && r.status !== 0) throw new Error("send");
        okBox.hidden = false;
        okBox.textContent = "Thank you — your request is with our studio. The mock-up "
          + "comes back to " + emailIn.value.trim() + " within 24 hours.";
        send.textContent = "Sent";
        if (setMock) setMock(true, emailIn.value.trim());
        window.setTimeout(close, 2600);
      }).catch(function () {
        send.disabled = false;
        send.textContent = revert;
        fail("That did not send. Email sales@megaprintery.com and we will pick it up from there.");
      });

      function fail(msg, focusEl) {
        errBox.textContent = msg;
        errBox.hidden = false;
        send.disabled = false;
        send.textContent = revert || "Send my request";
        if (focusEl) focusEl.focus();
      }
    });
  }

  /* ------------------------------------------------------------- cart -- */
  /* The stepper and Remove on the cart page were markup with nothing behind
     them: the buttons moved nothing and there was no update control, so the
     only way to change a quantity was to empty the cart and start again. */
  /* Changing a quantity is a round trip and then a full page load — a second
     or two in which the number the buyer just set, the line price and the
     total are all still the old ones and nothing on the page says so. Only
     the button that was pressed went dead, which left the rest of the cart
     live: a second press, or the other line's stepper, would race the first
     request and the reload would land on whichever answer arrived last.

     So the whole cart is held for the length of the request. The line being
     changed is marked, every control is taken out of reach, and the summary
     is dimmed because its figures are about to move. There was no catch on
     the request either, so a change that failed left the cart frozen with no
     way back; it now hands everything over and says what happened. */
  var cartBusy = false;

  function cartControls() {
    return { btns: $$(".mps-cartgrid [data-cart-qty],.mps-cartgrid [data-cart-remove]"),
             inputs: $$(".mps-cartgrid [data-cart-input]"),
             grid: $(".mps-cartgrid") };
  }

  function cartHold(key) {
    cartBusy = true;
    var c = cartControls();
    if (c.grid) c.grid.setAttribute("data-cart-busy", "");
    var owner = $('[data-cart-input][data-key="' + key + '"]') || $('[data-key="' + key + '"]');
    var line = owner && owner.closest && owner.closest(".mps-line");
    if (line) line.setAttribute("data-busy", "");
    c.btns.forEach(function (b) { b.disabled = true; });
    c.inputs.forEach(function (i) { i.readOnly = true; });
    var err = $("[data-cart-error]");
    if (err) err.hidden = true;
  }

  function cartRelease() {
    cartBusy = false;
    var c = cartControls();
    if (c.grid) c.grid.removeAttribute("data-cart-busy");
    $$(".mps-line[data-busy]").forEach(function (l) { l.removeAttribute("data-busy"); });
    c.btns.forEach(function (b) { b.disabled = false; });
    c.inputs.forEach(function (i) { i.readOnly = false; });
  }

  function cartPost(body) {
    cartHold(body.id);
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      window.location.reload();
    }).catch(function () {
      cartRelease();
      var err = $("[data-cart-error]");
      if (err) err.hidden = false;
    });
  }

  function initCart() {
    $$("[data-cart-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (cartBusy) return;
        var key = b.dataset.key;
        var input = $('[data-cart-input][data-key="' + key + '"]');
        var next = Math.max(0, (parseInt(input && input.value, 10) || 1) + parseInt(b.dataset.cartQty, 10));
        cartPost({ id: key, quantity: next });
      });
    });
    $$("[data-cart-remove]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (cartBusy) return;
        cartPost({ id: b.dataset.key, quantity: 0 });
      });
    });
    $$("[data-cart-input]").forEach(function (i) {
      var was = i.value;
      i.addEventListener("focus", function () { was = i.value; });
      i.addEventListener("change", function () {
        if (cartBusy) return;
        var n = parseInt(i.value, 10);
        /* An empty box read as nought, and nought takes the line out of the
           cart. Someone who cleared the field to type a new number and then
           clicked away lost the whole line. Nothing typed is nothing asked
           for: the number goes back the way it was. */
        if (isNaN(n) || n < 0) { i.value = was; return; }
        if (n === parseInt(was, 10)) { i.value = String(n); return; }
        cartPost({ id: i.dataset.key, quantity: n });
      });
    });
  }

  function boot() {
    $$("[data-product-root]").forEach(init);
    if (document.querySelector("[data-cart-remove]")) initCart();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
